import { DEFAULT_LANG } from 'constants/i18n'
import { FC, ReactNode, useEffect, useState } from 'react'
import { useListSelfcareOrderPositionsQuery } from 'store/api-slice/hooks'
import { useApp } from 'store/steps'
import { SelfcareAuthContext } from './useSelfcareAuth'

export const SelfcareAuthProvider: FC<{ children: ReactNode }> = ({
    children,
}) => {
    const { language } = useApp()
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const { refetch, data, isSuccess, isError } =
        useListSelfcareOrderPositionsQuery({
            _locale: language ?? DEFAULT_LANG,
        })

    const checkAuthentication = async () => {
        setIsLoading(true)
        await refetch()
    }

    useEffect(() => {
        // Refetch is not returning data, so we need to check if the data is available
        if (isSuccess && data) {
            setIsAuthenticated(true)
            setIsLoading(false)
        } else if (isError) {
            setIsAuthenticated(false)
            setIsLoading(false)
        }
    }, [data, isSuccess, isError])

    return (
        <SelfcareAuthContext.Provider
            value={{ isAuthenticated, isLoading, checkAuthentication }}
        >
            {children}
        </SelfcareAuthContext.Provider>
    )
}
